export default function ReformatNumber(stringNumber : string) : number{
    var thousandSeparator = Intl.NumberFormat().format(11111).replace(/\p{Number}/gu, '');
    var decimalSeparator = Intl.NumberFormat().format(1.1).replace(/\p{Number}/gu, '');

    return parseFloat(stringNumber
        .replace(new RegExp('\\' + thousandSeparator, 'g'), '')
        .replace(new RegExp('\\' + decimalSeparator), '.')
    );
}